import { createAction } from '@reduxjs/toolkit'
import { Month } from 'shared/DateUtils'
import { SegmentList } from '../Shared/helperFunctions'
import { ProgramsType, CurrencyType } from '../Shared/types'
import { LaunchProgramsState, LaunchProgramsType } from './launchProgramsSlice'
import { grhType, micromobilityType, flexType, qtfType } from '../Shared/types'

const changeSelectedDate = createAction<Month | null>(
  'launchPrograms/changeSelectedDate'
)

const changeSelectedSegments = createAction<SegmentList[]>(
  'launchPrograms/changeSelectedSegments'
)

const changeSelectedPrograms = createAction<LaunchProgramsType[]>(
  'launchPrograms/changeSelectedPrograms'
)

const changeProgramName = createAction<string>(
  'launchPrograms/changeProgramName'
)

const changeCurrency = createAction<CurrencyType>(
  'launchPrograms/changeCurrency'
)

const incompleteLaunch = createAction<boolean>(
  'launchPrograms/incompleteLaunch'
)

const fetchDraftProgramState = createAction<LaunchProgramsState>(
  'launchPrograms/fetchDraftProgramState'
)

const saveDraftProgramState = createAction<{
  selectedDate: Month
  selectedPrograms: ProgramsType[]
  selectedSegments: SegmentList[]
  programName: string
  currency: CurrencyType
  grh: grhType
  qtf: qtfType
  micromobility: micromobilityType
  flex: flexType
}>('launchPrograms/saveDraftProgramState')

const deleteDraftProgramState = createAction(
  'launchPrograms/deleteDraftProgramState'
)

const applyRehydrateState = createAction<any>(
  'launchPrograms/applyRehydrateState'
)

const clearStateForNewLaunch = createAction(
  'launchPrograms/clearStateForNewLaunch'
)

export const launchProgramsActions = {
  changeSelectedDate,
  changeSelectedSegments,
  changeSelectedPrograms,
  changeProgramName,
  changeCurrency,
  incompleteLaunch,
  fetchDraftProgramState,
  saveDraftProgramState,
  deleteDraftProgramState,
  applyRehydrateState,
  clearStateForNewLaunch,
}
